export default {
    // Header Section
    "discover_your": "Discover Your",
    "health_report": "Health Report",
    "astrological_health_insights": "Astrological Health Insights",
    "health_report_description": "Get comprehensive health analysis based on Vedic astrology. Understand your health vulnerabilities, disease predispositions, preventive care measures, and personalized wellness recommendations for optimal well-being.",

    // Service Information
    "enter_details_for_health_analysis": "Enter Your Details for Health Analysis",
    "complete_health_analysis": "Complete Health Analysis",
    "service_price": "Service Price",
    "comprehensive_health_analysis_note": "Deep analysis of your health patterns and personalized wellness guidance",

    // Form Fields
    "full_name": "Full Name",
    "enter_full_name": "Enter your full name",
    "name_health_influence": "Your name vibrations influence your health and healing patterns",
    "email_address": "Email Address",
    "enter_email_address": "Enter your email address",
    "phone_number": "Phone Number",
    "enter_phone_number": "Enter your phone number",
    "gender": "Gender",
    "male": "Male",
    "female": "Female",
    "other": "Other",
    "date_of_birth": "Date of Birth",
    "birth_date_health_insights": "Essential for determining health-related planetary positions",
    "time_of_birth": "Time of Birth",
    "exact_time_critical_for_health": "Precise time needed for accurate health house calculations",
    "place_of_birth": "Place of Birth",
    "place_of_birth_placeholder": "City, State, Country",
    "location_essential_for_health": "Location affects planetary positions influencing health",
    "preferred_language": "Preferred Language",
    "english": "English",
    "hindi": "Hindi",
    "telugu": "Telugu",
    "kannada": "Kannada",
    "language_note": "Your health analysis will be delivered in the selected language",

    // Core Health Features
    "health_vulnerabilities_analysis": "Health Vulnerabilities Analysis",
    "disease_predisposition_insights": "Disease Predisposition Insights",
    "preventive_health_measures": "Preventive Health Measures",
    "dietary_lifestyle_recommendations": "Dietary & Lifestyle Recommendations",
    "healing_gemstones_remedies": "Healing Gemstones & Remedies",
    "pdf_download": "Comprehensive PDF Report",

    "what_you_get": "What Your Health Analysis Includes",
    "comprehensive_health_chart": "Comprehensive Health Chart",
    "body_system_analysis": "Body System Analysis",
    "preventive_care_guidance": "Preventive Care Guidance",
    "wellness_enhancement_tips": "Wellness Enhancement Tips",

    // Actions & Buttons
    "pay_and_generate_analysis": "Get My Health Analysis",
    "processing_payment": "Processing Payment",
    "processing_request": "Generating Analysis",

    // Payment & Success Messages
    "thank_you": "Thank You",
    "payment_successful": "Payment Successful!",
    "health_analysis_processing": "Your health analysis is being prepared by our expert medical astrologers. You'll receive detailed insights into your health patterns and personalized wellness guidance.",
    "order_id": "Order ID",
    "payment_id": "Payment ID",
    "amount_paid": "Amount Paid",

    // Delivery Information
    "delivery_information": "Delivery Information",
    "delivery_time": "Analysis Delivery",
    "within_12_hours_delivery_note": "Your detailed health report will be ready within 12 hours",
    "whatsapp_notification": "WhatsApp Updates",
    "whatsapp_delivery_note": "Receive instant notifications on WhatsApp",
    "email_delivery": "Email Delivery",
    "email_delivery_note": "Complete analysis delivered to",

    // What You'll Receive
    "what_youll_receive": "Your Health Analysis Package",
    "detailed_health_report": "Comprehensive Health Report (PDF)",
    "body_system_vulnerability_analysis": "Body System Vulnerability Analysis",
    "preventive_healthcare_plan": "Preventive Healthcare Plan",
    "dietary_wellness_guidelines": "Dietary & Wellness Guidelines",
    "healing_remedies_recommendations": "Healing Remedies & Recommendations",

    // Visual Content
    "sample_health_analysis": "Sample Health Analysis",
    "health_strength_indicator": "Health Strength Indicator",
    "sample_health_reading": "Strong vitality with focus on cardiovascular wellness",
    "sample_health_preview": "Preview of your personalized health analysis with system insights",
    "health_categories": "Health Categories",

    // Health System Types
    "cardiovascular": "Cardiovascular",
    "neurological": "Neurological", 
    "respiratory": "Respiratory",
    "digestive": "Digestive",
    "skeletal": "Skeletal",
    "immune_system": "Immune System",

    // Status & Processing
    "your_health_analysis_status": "Your Health Analysis Status",
    "processing_your_analysis": "Analyzing Your Health Patterns",
    "analysis_processing_message": "Our medical astrology experts are studying your planetary positions to determine your health vulnerabilities and wellness recommendations.",
    "request_id": "Analysis ID",
    "status": "Status",
    "processing": "In Progress",
    "pending": "Queued",
    "email_notification_sent": "Confirmation email sent",
    "whatsapp_update_coming": "WhatsApp updates enabled",
    "delivery_within_12_hours": "Report ready within 12 hours",

    // Support & Contact
    "contact_support": "Contact Health Support",
    "need_help": "Need guidance?",
    "contact_us_at": "Reach us at",

    // Error Messages
    "please_fill_all_required_fields": "Please complete all required birth details",
    "payment_failed": "Payment unsuccessful. Please try again.",
    "processing_failed": "Analysis processing failed. Contact our support team.",

    // Health-Specific Elements
    "sixth_house": "6th House (Health House)",
    "eighth_house": "8th House (Chronic Health)",
    "twelfth_house": "12th House (Hospitalization)",
    "ascendant_health": "Ascendant & Overall Vitality",
    "moon_health": "Moon & Mental Health",
    "mars_energy": "Mars & Physical Energy",

    // Body Systems Analysis
    "circulatory_system": "Circulatory System",
    "nervous_system": "Nervous System",
    "respiratory_system": "Respiratory System",
    "digestive_system": "Digestive System",
    "musculoskeletal_system": "Musculoskeletal System",
    "endocrine_system": "Endocrine System",
    "reproductive_system": "Reproductive System",
    "excretory_system": "Excretory System",

    // Health Vulnerabilities
    "genetic_predispositions": "Genetic Predispositions",
    "chronic_condition_risks": "Chronic Condition Risks",
    "acute_illness_patterns": "Acute Illness Patterns",
    "mental_health_factors": "Mental Health Factors",
    "stress_vulnerability": "Stress Vulnerability Areas",
    "injury_prone_areas": "Injury Prone Areas",

    // Preventive Measures
    "early_warning_signs": "Early Warning Signs",
    "regular_checkup_schedule": "Regular Checkup Schedule",
    "screening_recommendations": "Health Screening Recommendations",
    "vaccination_guidance": "Vaccination Guidance",
    "lifestyle_modifications": "Lifestyle Modifications",
    "exercise_prescriptions": "Exercise Prescriptions",

    // Dietary Recommendations
    "constitutional_diet": "Constitutional Diet Plan",
    "foods_to_include": "Foods to Include",
    "foods_to_avoid": "Foods to Avoid",
    "meal_timing": "Optimal Meal Timing",
    "seasonal_adjustments": "Seasonal Dietary Adjustments",
    "supplementation_needs": "Supplementation Needs",

    // Lifestyle Guidance
    "sleep_patterns": "Optimal Sleep Patterns",
    "exercise_routine": "Recommended Exercise Routine",
    "stress_management": "Stress Management Techniques",
    "work_life_balance": "Work-Life Balance",
    "environmental_factors": "Environmental Health Factors",
    "social_health": "Social & Emotional Health",

    // Healing & Remedies
    "ayurvedic_remedies": "Ayurvedic Remedies",
    "herbal_recommendations": "Herbal Recommendations",
    "gemstone_therapy": "Gemstone Therapy",
    "color_therapy": "Color Therapy",
    "sound_healing": "Sound Healing",
    "yoga_practices": "Therapeutic Yoga Practices",
    "meditation_techniques": "Healing Meditation Techniques",
    "breathing_exercises": "Pranayama & Breathing Exercises",

    // Mental Health
    "psychological_patterns": "Psychological Patterns",
    "emotional_balance": "Emotional Balance",
    "mental_clarity": "Mental Clarity Enhancement",
    "memory_concentration": "Memory & Concentration",
    "anxiety_management": "Anxiety Management",
    "depression_prevention": "Depression Prevention",

    // Timing & Cycles
    "health_cycles": "Personal Health Cycles",
    "vulnerable_periods": "Health Vulnerable Periods",
    "recovery_periods": "Natural Recovery Periods",
    "optimal_treatment_timing": "Optimal Treatment Timing",
    "surgery_timing": "Surgical Procedure Timing",
    "detox_periods": "Detoxification Periods",

    // Age-Related Health
    "childhood_health": "Childhood Health Patterns",
    "adolescent_health": "Adolescent Health Issues",
    "adult_health": "Adult Health Maintenance",
    "middle_age_concerns": "Middle Age Health Concerns",
    "senior_health": "Senior Health Guidance",
    "longevity_factors": "Longevity Factors",

    // Women's Health
    "menstrual_health": "Menstrual Health",
    "fertility_factors": "Fertility Factors",
    "pregnancy_guidance": "Pregnancy Health Guidance",
    "menopause_management": "Menopause Management",
    "hormonal_balance": "Hormonal Balance",

    // Men's Health
    "vitality_enhancement": "Vitality Enhancement",
    "prostate_health": "Prostate Health",
    "testosterone_balance": "Testosterone Balance",
    "cardiovascular_focus": "Cardiovascular Focus",
    "stress_related_issues": "Stress-Related Issues",

    // Specialty Areas
    "skin_health": "Skin & Beauty Health",
    "eye_health": "Eye Health",
    "dental_health": "Dental Health",
    "hair_health": "Hair Health",
    "joint_health": "Joint Health",
    "metabolic_health": "Metabolic Health",

    // Emergency Preparedness
    "health_emergencies": "Health Emergency Preparedness",
    "first_aid_guidance": "First Aid Guidance",
    "emergency_contacts": "Emergency Healthcare Contacts",
    "medication_management": "Medication Management",
    "allergy_alerts": "Allergy Alerts",

    // Holistic Wellness
    "mind_body_connection": "Mind-Body Connection",
    "spiritual_healing": "Spiritual Healing Practices",
    "energy_healing": "Energy Healing Modalities",
    "chakra_balancing": "Chakra Balancing",
    "aura_cleansing": "Aura Cleansing",
    "holistic_integration": "Holistic Health Integration"
};
